import { useEffect, useState } from 'react'
import { Box, BoxProps, Container } from '@mui/material'

import LogoHappa from '@/components/base/logo-happa'
import LogoSais from '@/components/base/logo-sais'
import { useLenisStore } from '@/contexts/lenis'
import { isHappa, isSais } from '@/hooks'
import { useLocaleStore } from '@/store/locale'

const SCROLL_THRESHOLD = 50

const LandingHeader = (props: BoxProps) => {
  const currentLocale = useLocaleStore((state) => state.currentLocale)
  const [isMinimized, setIsMinimized] = useState(false)

  useEffect(() => {
    const unsubscribe = useLenisStore.subscribe(
      (state) => state.scroll,
      (scroll) => setIsMinimized(scroll > SCROLL_THRESHOLD)
    )
    return () => unsubscribe()
  }, [])

  return (
    <Box
      component="header"
      sx={{
        position: 'fixed',
        zIndex: 100,
        width: '100%',
        borderBottom: '0.1rem solid',
        borderColor: (theme) => theme.palette.grey[100],
        background: (theme) => theme.palette.text.primaryContrastText
      }}
      {...props}
    >
      <Container
        sx={(theme) => ({
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pt: theme.spacing(1),
          pb: theme.spacing(1)
        })}
      >
        <Box
          sx={(theme) => ({
            height: isMinimized
              ? theme.customSizes.headerLogoHeightMinimized
              : theme.customSizes.headerLogoHeight,
            width: 'auto',
            display: 'flex',
            alignItems: 'center',
            transition: `height 0.3s ${theme.customEasings.outCubic}`
          })}
        >
          {isSais && currentLocale !== undefined ? (
            <LogoSais
              sx={{
                width: { xs: '5rem', sm: isMinimized ? '5.4rem' : '10rem' },
                transition: (theme: any) => `width 0.3s ${theme.customEasings.outCubic}`,
                display: 'flex',
                alignItems: 'center'
              }}
            />
          ) : null}
          {isHappa && currentLocale !== undefined ? (
            <LogoHappa
              sx={{
                width: { xs: '8rem', sm: '17rem' },
                transition: (theme: any) => `width 0.3s ${theme.customEasings.outCubic}`,
                display: 'flex',
                alignItems: 'center'
              }}
            />
          ) : null}
        </Box>
      </Container>
    </Box>
  )
}

export default LandingHeader
